import type { CartState } from "../lib/cart";
import type { GroceryItem } from "../lib/items";

export function CartDock({
  cart,
  itemsById,
  onRemove,
}: {
  cart: CartState;
  itemsById: Map<string, GroceryItem>;
  onRemove: (id: string) => void;
}) {
  const ids = Object.keys(cart).filter((id) => (cart[id] ?? 0) > 0 && itemsById.has(id));
  if (ids.length === 0) return null;

  return (
    <div className="cartDock" aria-label="Cart">
      <div className="cartDockInner">
        <div className="cartDockItems" aria-label="Cart items">
          {ids.map((id) => {
            const item = itemsById.get(id);
            if (!item) return null;
            return (
              <button
                key={id}
                className="cartDockItem"
                type="button"
                onClick={() => {
                  onRemove(id);
                }}
                aria-label={`${item.name} — remove from cart`}
              >
                <span className="cartDockX" aria-hidden="true">
                  ×
                </span>
                <img className="cartDockImg" src={item.imageUrl} alt={item.name} draggable={false} />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
